var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalhaTerror3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 260,
    viewBox: "0 0 214 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 213,
    height: 260,
    rx: 8,
    fill: "#ECE6F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.682 112.44C170.682 149.683 142.821 168.305 109.706 179.106C107.972 179.656 106.089 179.629 104.373 179.031C71.1786 168.305 43.3175 149.683 43.3175 112.44L43.3175 60.2984C43.3175 58.3228 44.1562 56.4282 45.649 55.0313C47.1419 53.6344 49.1666 52.8496 51.2778 52.8496C67.1984 52.8496 87.0992 43.9111 100.95 32.589C102.637 31.2408 104.782 30.5 107 30.5C109.218 30.5 111.363 31.2408 113.05 32.589C126.98 43.9856 146.802 52.8496 162.722 52.8496C164.833 52.8496 166.858 53.6344 168.351 55.0313C169.844 56.4282 170.682 58.3228 170.682 60.2984L170.682 112.44Z",
    fill: "url(#paint0_linear_2162_30723)",
    stroke: "url(#paint1_linear_2162_30723)",
    strokeWidth: 3.91429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.557 79.7228C109.856 71.4566 95.0229 65.5065 89.9469 66.3915C91.5236 60.2973 107.117 60.2743 112.661 55.9672C115.056 62.9711 118.604 63.4423 122.119 63.9909L123.983 54.4859L129.425 60.4883L136.731 56.9856L134.867 66.4906C138.329 67.3101 141.792 68.2138 146.655 62.6331C150.162 68.7149 162.355 74.1865 161.514 80.4249C157.148 77.6885 142.284 77.8155 138.513 85.2046C133.004 84.1243 126.682 86.9757 122.902 93.7556C121.961 86.05 116.067 80.8031 110.557 79.7228Z",
    fill: "#050505",
    stroke: "#050505",
    strokeWidth: 4.5581,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.833 67.964L133.378 67.83L135.067 63.6281L130.833 67.964Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.886 66.8717L122.58 65.7867L122.603 61.258L124.886 66.8717Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.142 88.3965C118.674 88.3965 116.205 89.316 114.285 91.155C113.43 90.3352 112.376 89.6782 111.194 89.228C110.011 88.7778 108.727 88.5449 107.428 88.5449C106.129 88.5449 104.845 88.7778 103.663 89.228C102.48 89.6782 101.426 90.3352 100.571 91.155C98.6511 89.316 96.1826 88.3965 93.7141 88.3965C86.0342 88.3965 80 97.5914 80 109.085C80 120.579 86.0342 129.774 93.7141 129.774C96.1826 129.774 98.6511 128.854 100.571 127.015C101.426 127.835 102.48 128.492 103.663 128.942C104.845 129.392 106.129 129.625 107.428 129.625C108.727 129.625 110.011 129.392 111.194 128.942C112.376 128.492 113.43 127.835 114.285 127.015C116.205 128.854 118.674 129.774 121.142 129.774C128.822 129.774 134.856 120.579 134.856 109.085C134.856 97.5914 128.822 88.3965 121.142 88.3965Z",
    fill: "url(#paint2_linear_2162_30723)",
    stroke: "#050505",
    strokeWidth: 4.38851,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103 81.5C105.194 83.7987 105.194 86.0975 105.194 86.0975L103 81.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103 81.5C105.194 83.7987 105.194 86.0975 105.194 86.0975",
    stroke: "#050505",
    strokeWidth: 4.38851,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2627 116.608L98.6512 120.996L103.04 116.608L107.428 120.996L111.817 116.608L116.205 120.996L120.594 116.608",
    stroke: "#050505",
    strokeWidth: 4.38851,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2533 101.118L102.463 107.274",
    stroke: "#050505",
    strokeWidth: 3.29138,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2533 101.118L92.3786 108.643L102.463 107.274",
    stroke: "#050505",
    strokeWidth: 3.29138,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M123.344 103.22L123.51 108.258L116.5 107.281L117.429 105.843L123.344 103.22Z",
    fill: "#050505"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0406 103.22L91.8752 108.258L98.8849 107.281L97.9562 105.843L92.0406 103.22Z",
    fill: "#050505"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M125.982 101.12L112.772 107.275",
    stroke: "#050505",
    strokeWidth: 3.29138,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.982 101.12L122.857 108.644L112.772 107.275",
    stroke: "#050505",
    strokeWidth: 3.29138,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4039 140.783C96.2492 135.472 106.121 132.328 109.361 133.141C108.631 129.126 98.5501 128.372 95.1696 125.324C93.2892 129.739 90.9729 129.876 88.6741 130.064L87.9194 123.83L84.1164 127.453L79.5588 124.842L80.3134 131.076C78.0362 131.442 75.7542 131.862 72.8746 128.023C70.319 131.789 62.176 134.749 62.4245 138.823C65.377 137.26 74.9809 138.047 77.0692 143.003C80.6824 142.565 84.6345 144.709 86.7577 149.271C87.7308 144.334 91.7908 141.221 95.4039 140.783Z",
    fill: "#050505",
    stroke: "#050505",
    strokeWidth: 2.95498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8516 132.219L81.2128 132.012L80.3196 129.215L82.8516 132.219Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7489 131.795L88.2909 131.203L88.4909 128.274L86.7489 131.795Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6264 202.136V222.5H76.8026L66.4517 207.565H66.2628V222.5H63.1903V202.136H66.0341L76.3949 217.091H76.5838V202.136H79.6264ZM83.8697 222.5V207.227H86.8427V222.5H83.8697ZM84.1481 205.189L86.4748 200.605H89.6069L86.5245 205.189H84.1481ZM103.908 207.227L98.3693 222.5H95.1875L89.6392 207.227H92.831L96.6989 218.98H96.858L100.716 207.227H103.908ZM112.765 222.808C111.26 222.808 109.964 222.487 108.877 221.844C107.796 221.194 106.961 220.283 106.371 219.109C105.788 217.929 105.496 216.547 105.496 214.963C105.496 213.399 105.788 212.02 106.371 210.827C106.961 209.634 107.783 208.702 108.837 208.033C109.898 207.363 111.137 207.028 112.556 207.028C113.417 207.028 114.253 207.171 115.061 207.456C115.87 207.741 116.596 208.188 117.239 208.798C117.882 209.408 118.389 210.2 118.76 211.175C119.132 212.143 119.317 213.319 119.317 214.705V215.759H107.176V213.531H116.404C116.404 212.749 116.245 212.056 115.926 211.453C115.608 210.843 115.161 210.363 114.584 210.011C114.014 209.66 113.345 209.484 112.576 209.484C111.74 209.484 111.011 209.69 110.388 210.101C109.772 210.505 109.294 211.036 108.956 211.692C108.625 212.341 108.459 213.047 108.459 213.81V215.55C108.459 216.571 108.638 217.439 108.996 218.155C109.361 218.871 109.868 219.418 110.517 219.795C111.167 220.167 111.926 220.352 112.794 220.352C113.358 220.352 113.872 220.273 114.336 220.114C114.8 219.948 115.201 219.703 115.539 219.378C115.877 219.053 116.135 218.652 116.314 218.175L119.128 218.682C118.903 219.51 118.498 220.236 117.915 220.859C117.338 221.476 116.613 221.956 115.738 222.301C114.869 222.639 113.878 222.808 112.765 222.808ZM125.589 202.136V222.5H122.616V202.136H125.589ZM144.048 222.778C142.683 222.778 141.463 222.543 140.389 222.072C139.322 221.602 138.477 220.949 137.854 220.114C137.237 219.272 136.906 218.297 136.859 217.19H139.982C140.021 217.794 140.223 218.317 140.588 218.761C140.959 219.199 141.443 219.537 142.04 219.776C142.636 220.014 143.299 220.134 144.028 220.134C144.83 220.134 145.54 219.994 146.156 219.716C146.779 219.437 147.267 219.05 147.618 218.553C147.969 218.049 148.145 217.469 148.145 216.812C148.145 216.13 147.969 215.53 147.618 215.013C147.273 214.489 146.766 214.078 146.097 213.78C145.434 213.482 144.632 213.332 143.69 213.332H141.97V210.827H143.69C144.446 210.827 145.109 210.691 145.679 210.419C146.256 210.147 146.706 209.769 147.031 209.286C147.356 208.795 147.518 208.222 147.518 207.565C147.518 206.936 147.376 206.389 147.091 205.925C146.813 205.454 146.415 205.086 145.898 204.821C145.387 204.556 144.784 204.423 144.088 204.423C143.425 204.423 142.805 204.546 142.229 204.791C141.659 205.03 141.195 205.375 140.837 205.825C140.479 206.269 140.286 206.803 140.26 207.426H137.287C137.32 206.326 137.645 205.358 138.261 204.523C138.884 203.687 139.706 203.035 140.727 202.564C141.748 202.093 142.882 201.858 144.128 201.858C145.434 201.858 146.561 202.113 147.509 202.624C148.463 203.127 149.199 203.8 149.716 204.642C150.24 205.484 150.498 206.405 150.491 207.406C150.498 208.546 150.18 209.514 149.537 210.31C148.901 211.105 148.052 211.639 146.991 211.911V212.07C148.344 212.275 149.391 212.812 150.134 213.68C150.883 214.549 151.254 215.626 151.247 216.912C151.254 218.032 150.942 219.036 150.312 219.925C149.689 220.813 148.838 221.512 147.757 222.023C146.677 222.527 145.44 222.778 144.048 222.778Z",
    fill: "#4C4452"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_30723",
    x1: 107,
    y1: 179.5,
    x2: 107,
    y2: 30.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#653388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8256C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_30723",
    x1: 107,
    y1: 179.5,
    x2: 107,
    y2: 30.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2162_30723",
    x1: 107.428,
    y1: 88.3965,
    x2: 107.428,
    y2: 129.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326923,
    stopColor: "#FF6200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#990000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalhaTerror3);
export default __webpack_public_path__ + "static/media/Medalha_terror_3.787fcdfd07a128a9ab94f9c8e702e923.svg";
export { ForwardRef as ReactComponent };